import React from "react";

export default function Container({ containerId, containerClass, children, onClick }) {
	return (
		<div id={containerId} className={`${containerClass}`} onClick={onClick}>
			{children}
		</div>
	);
}
